import { FiArrowUpRight, FiGithub } from 'react-icons/fi';
import { useTranslate } from 'react-translate';

const Card = ({
  img,
  title,
  description,
  liveHref,
  sourceHref,
  tech,
  index,
}) => {
  const t = useTranslate('Projects');

  return (
    <article
      className='project-card'
      data-aos='fade-up'
      data-aos-delay={index * 70}
    >
      <div className='project-image-wrap'>
        <img src={img} alt={title} />
      </div>

      <div className='relative z-10 flex flex-1 flex-col p-6'>
        <div className='mb-5 flex items-center justify-between gap-4'>
          <div>
            <p className='text-xs uppercase tracking-[0.22em] text-[var(--blue)]'>
              {t('featured')}
            </p>
            <h3 className='mt-2 text-2xl font-extrabold text-[var(--text-main)]'>{title}</h3>
          </div>
        </div>

        <p className='section-copy text-[0.98rem]'>{description}</p>

        <div className='mt-6 flex flex-wrap gap-2'>
          {tech.map((item) => (
            <span key={`${title}-${item}`} className='tag-chip'>
              {item}
            </span>
          ))}
        </div>

        <div className='mt-auto flex flex-wrap gap-3 pt-8'>
          <a
            href={liveHref}
            target='_blank'
            rel='noreferrer'
            className='primary-link'
          >
            {t('live')}
            <FiArrowUpRight />
          </a>
          {sourceHref && (
            <a
              href={sourceHref}
              target='_blank'
              rel='noreferrer'
              className='secondary-link'
            >
              {t('source')}
              <FiGithub />
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

export default Card;
